import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ArrayUtils, isDefined, isEmpty } from 'ts-utils';
import { Color } from '../../config/Color';
import { Spacer } from '../styles/Dividers';
import { BodySM, Heading3, Heading4 } from '../styles/Typography';
import { PaddedLightContainer } from './ColoredContainers';

export type SummaryData = Array<{
  heading?: string;
  items: Array<{
    heading: string;
    items: string[];
  }>;
}>;

type Props = {
  heading?: string;
  data: SummaryData;
};

export const SummaryCard: FunctionComponent<Props> = (props) => (
  <SummaryCardContainer data-test="SummaryCard">
    {isDefined(props.heading) && <StyledHeading>{props.heading}</StyledHeading>}
    <SummaryContentContainer>
      {props.data.map((section, index) => (
        <div key={index}>
          <Spacer space={12} />
          {/* Show sub-heading */}
          {!isEmpty(section.heading) && <Heading3>{section.heading}</Heading3>}
          {
            // Sub-sub heading and comma-joined list of items
            // but only if the list of items is not empty
            section.items.map((attribute, attributeIndex) => (
              <div key={attributeIndex}>
                {attribute.items.length > 0 && (
                  <BodySM>
                    <AttributeHeader>{attribute.heading}:</AttributeHeader>
                    &nbsp;
                    <span data-test={attribute.heading}>
                      {ArrayUtils.toHumanReadableString(attribute.items)}
                    </span>
                  </BodySM>
                )}
              </div>
            ))
          }
        </div>
      ))}
    </SummaryContentContainer>
  </SummaryCardContainer>
);

const SummaryCardContainer = styled.div`
  background-color: ${Color.surface.accent};
  border-radius: 30px;
`;

const SummaryContentContainer = styled(PaddedLightContainer)`
  margin-top: 0;
  text-align: left;
`;

const StyledHeading = styled(Heading4)`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  margin-bottom: 0;
  margin-left: ${({ theme }) => theme.spacing._20px};
  margin-right: ${({ theme }) => theme.spacing._20px};
`;

const AttributeHeader = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;
